import React from "react";
import "../component/productInvoiceTable.css";
import { formatRupiah } from "../../../helper/formatNumber";
import { Loader } from "../../../components/ui";

const ProductInvoiceTable = ({
  page,
  product,
  onPaymentInvoiceClicked,
  onEditProductClicked,
  onDeleteProductClicked,
  onDetailProductClicked,
  isLoading = false,
}) => {
  const editProduct = (product) => {
    onEditProductClicked(product);
  };

  const deleteProduct = (product) => {
    onDeleteProductClicked(product);
  };
  const detailProduct = (product) => {
    onDetailProductClicked(product);
  };
  return (
    <div className="product-invoice-table-container">
      <table className="product-invoice-table">
        <thead>
          <tr>
            <th width="50px">No</th>
            <th>Nomor Dokumen</th>
            <th>Nama Supplier</th>
            <th>Tanggal Invoice</th>
            <th>Jatuh Tempo</th>
            <th>Total Diskon</th>
            <th>Total Order</th>
            <th>Tax</th>
            <th>Payment Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={10} style={{ textAlign: 'center' }}>
                <Loader title="Sedang memuat data, mohon tunggu..." />
              </td>
            </tr>
          ) : (
            product.map((invoice, index) => (
              <tr key={index}>
                <td>{(page - 1) * 10 + index + 1}</td>
                <td>{invoice.product_invoice_document_number}</td>
                <td>{invoice.product_invoice_supplier.supplier_name}</td>
                <td>{invoice.product_invoice_date}</td>
                <td>{invoice.product_invoice_due_date}</td>
                <td>{formatRupiah(invoice.product_invoice_total_discount)}</td>
                <td>{formatRupiah(invoice.product_invoice_total_order)}</td>
                <td>{formatRupiah(invoice.product_invoice_total_tax)}</td>
                <td
                  style={{
                    color: invoice.product_invoice_is_paid ? "black" : "red",
                  }}
                >
                  {invoice.product_invoice_is_paid
                    ? "Sudah Bayar"
                    : "Belum Bayar"}
                </td>
                <td>
                  <button
                    className={
                      invoice.product_invoice_is_paid
                        ? "pay-invoice-button-disabled"
                        : "pay-invoice-button"
                    }
                    onClick={() => {
                      onPaymentInvoiceClicked(invoice);
                    }}
                    disabled={invoice.product_invoice_is_paid}
                  >
                    Bayar Sekarang
                  </button>

                  <button
                    className="edit-doctor-specialist-button"
                    onClick={() => {
                      editProduct(invoice);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="detail-doctor-specialist-button"
                    onClick={() => {
                      detailProduct(invoice);
                    }}
                  >
                    Detail
                  </button>
                  <button
                    className="delete-doctor-specialist-button"
                    onClick={() => {
                      deleteProduct(invoice);
                    }}
                  >
                    Hapus
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ProductInvoiceTable;
